module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9905d7791a40b5238b05a398692c2ab9.png";